import { CheckBoxIcon } from "../../../page-components/icons";

const CheckboxRegular = ({ value, setValue, content, htmlFor }) => {
  return (
    <div className="checkbox__regularContainer">
      <label className="checkbox__regularLabel" htmlFor={htmlFor}>
        {value ? (
          <CheckBoxIcon
            className="icon--xs checkbox--checked"
            color="white"
            onClick={() => setValue(!value)}
          />
        ) : (
          <CheckBoxIcon
            className="icon--xs checkbox--unchecked"
            color="white"
            onClick={() => setValue(!value)}
          />
        )}

        <input
          name={htmlFor}
          className="checkbox__regularCheckbox"
          type="checkbox"
        />
        <p>{content}</p>
      </label>
    </div>
  );
};

export default CheckboxRegular;
